const axios = require('axios')

module.exports = axios.create({
    // baseURL: 'https://loyal.ws',
    baseURL: '',
    withCredentials: true
    // timeout: 1000,
    // headers: {'X-Custom-Header': 'foobar'}
})
